// extracted by mini-css-extract-plugin
module.exports = {"root":"Feed_root__bGJRB","App":"Feed_App__3323w","User":"Feed_User__1mAQb","Inbox":"Feed_Inbox__1gLM1","Feed":"Feed_Feed__2lilR"};